import TabPage from "./../factories/tab-page";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import * as moment from "moment";
class SystemMessage extends BaseViewModel {
    ValidFromJs: KnockoutObservable<any>;
    ValidToJs: KnockoutObservable<any>;
    SystemText = ko.observable();
    ValidFrom: KnockoutObservable<any>;
    ValidTo: KnockoutObservable<any>;
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.ValidFromJs() === "" || this.ValidFromJs() === null) {
            completed = false;
        }
        if (this.ValidToJs() === "" || this.ValidToJs() === null) {
            completed = false;
        }
        if (this.SystemText() === "" || this.SystemText() === null) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "SystemMessage/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init();
    }

    public loaded = () => {
        super.loaded();
        this.ValidFrom["Formatted"] = ko.pureComputed(() => {
            if (this.ValidFromJs()) {
                return moment(this.ValidFromJs(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return '';
            }
        });
        this.ValidTo["Formatted"] = ko.pureComputed(() => {
            if (this.ValidToJs()) {
                return moment(this.ValidToJs(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            } else {
                return '';
            }
        });
    }
}
export default SystemMessage;